import { render } from "./AggiungiVociFatturaMassivo.vue?vue&type=template&id=b4b0c7fc&scoped=true"
import script from "./AggiungiVociFatturaMassivo.vue?vue&type=script&lang=js"
export * from "./AggiungiVociFatturaMassivo.vue?vue&type=script&lang=js"

import "./AggiungiVociFatturaMassivo.vue?vue&type=style&index=0&id=b4b0c7fc&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b0c7fc"]])

export default __exports__